var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.num)?_c('div',{staticClass:"upDown"},[(_vm.num == 'new')?_c('p',{staticClass:"upDown__new"},[_vm._v("NEW")]):(_vm.num != '0')?_c('p',{staticClass:"upDown__number",class:[ _vm.num > 0 ? 'up' : 'down' ]},[_vm._v(_vm._s(Math.abs(_vm.num)))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }